import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  CollectionReference,
  Query,
} from "@angular/fire/firestore";
import { User } from "../@core/data/users";
import { UserService } from "../@core/services/user.service";
import Like from "../models/like.model";
import * as firebase from "firebase/app";
import "firebase/firestore";
import { WhereList } from "../models/pagination";
import { environment } from "../../environments/environment";
import { NotificationService } from "./notifications.service";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class LikeService {
  visibility = environment.visibility;
  baseUrl = environment.apiUrl;
  userLogin: User;
  private dbPath = "/likes";

  collRef: AngularFirestoreCollection<Like>;

  constructor(
    private http: HttpClient,
    private db: AngularFirestore,
    private userStore: UserService,
    private notiService: NotificationService
  ) {
    this.collRef = db.collection(this.dbPath);

    this.userStore.getCurrentUser().subscribe((user: User) => {
      this.userLogin = user;
    });
  }

  getMyLike(mode: string, refId: string, uid: string): any {
    const createdBy = this.userLogin ? this.userLogin.uid : uid;

    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true)
      .where("mode", "==", mode)
      .where("refId", "==", refId)
      .where("createdBy", "==", createdBy)
      .orderBy("updatedOn", "desc")
      .limit(1);

    return ref.get();
  }

  get(id: string) {
    return this.collRef.doc(id).valueChanges();
  }

  create(like: Like): any {
    like.refAuthor = like.refAuthor ? like.refAuthor : null;

    like.value = true;
    like.isActive = true;
    like.isDeleted = false;
    like.createdOn = new Date();
    like.createdBy = this.userLogin.uid;
    like.updatedOn = new Date();
    like.updatedBy = this.userLogin.uid;
    like.author = this.userLogin;
    like.visibility = this.visibility;

    return this.collRef.add({ ...like }).then((docRef) => {
      like.id = docRef.id;

      const syncData = { id: like.id, ...like };
      this.sync(syncData);

      if (like.refUid != this.userLogin.uid) {
        this.notiService.create(
          "Thích",
          like.mode,
          like.refId,
          like.id,
          like.refTitle,
          like.refDescription,
          like.refUid,
          like.refUrl,
          ""
        );
      }

      return like;
    });
  }

  update(like: Like): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    return this.collRef
      .doc(like.id)
      .update({
        refTitle: like.refTitle,
        value: like.value,
        updatedOn: updatedOn,
        updatedBy: updatedBy,
        author: this.userLogin,
      })
      .then((docRef) => {
        like.createdBy = like.createdBy ? like.createdBy : updatedBy;
        const syncData = { id: like.id, ...like };
        this.sync(syncData);

        return docRef;
      });
  }

  sync(content) {
    content.createdOn ? delete content.createdOn : null;
    content.updatedOn ? delete content.updatedOn : null;

    content.fsId = content.id ? content.id : "";

    if (environment.syncLive) {
      this.http.post(this.baseUrl + "/Likes", content).subscribe({
        next: () => {},
        error: (err) => {},
      });
    }
  }
}
